<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="openPlanForm('new')"
        :disabled="loading"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>Adicionar
      </v-btn>
    </v-card-title>

    <v-data-table :headers="headers" :items="plans" :pagination.sync="pag">
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.company }}</td>
        <td>{{ props.item.contract_time }} meses</td>
        <td>
          {{
            props.item.utility_company
              ? props.item.utility_company.toUpperCase()
              : "-"
          }}
        </td>
        <td>{{ props.item.status | FormatPlanStatus }}</td>
        <td>{{ props.item.created_at | formatarDate }}</td>
        <td>{{ props.item.discount }}%</td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.person_type | formatPersonType }}</td>
        <td>{{ props.item.recommended ? "Sim" : "Não" }}</td>
        <td>{{ props.item.promotional ? "Sim" : "Não" }}</td>
        <td>{{ props.item.started_at | formatarDate }}</td>

        <td class="text-xs-right">
          <v-tooltip bottom v-if="props.item.cooperative_statute_url">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
                :href="props.item.cooperative_statute_url"
                target="_blank"
              >
                <v-icon left> summarize </v-icon>
              </v-btn>
            </template>
            <span>Estatuto</span>
          </v-tooltip>

          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openPlanForm('edit', props.item)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>

          <v-tooltip bottom v-if="props.item.status !== 'disabled'">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="error"
                >
                  cancel
                </v-icon>
              </v-btn>
            </template>
            <span>Desativar Plano</span>
          </v-tooltip>

          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item, props.item.status)"
                  color="success"
                >
                  task
                </v-icon>
              </v-btn>
            </template>
            <span>Reativar Plano</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_modify_status_plan" max-width="290" dark>
      <v-card color="grey">
        <v-card-title class="headline"
          >Tem certeza que deseja
          {{ newPlanStatus !== "disabled" ? "ativar" : "desativar" }} esse
          plano?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            right
            @click="dialog_modify_status_plan = false"
            dark
          >
            Não
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green" right dark @click="activateOrDesactivate()">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <plans-form
      v-if="planFormData.openDialog"
      :dialog="planFormData.openDialog"
      :type="planFormData.type"
      :plan="planFormData.plan"
      @closeDialog="planFormData.openDialog = false"
    />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { updatePlansFb } from "../../services/plans";

export default {
  components: {
    PlansForm: () => import("./PlansForm.vue"),
  },

  data() {
    return {
      dialog_modify_status_plan: false,
      newPlanStatus: null,
      planFormData: {
        openDialog: false,
        plan: null,
        type: "new",
        key: 0,
      },
      headers: [
        {
          text: "Nome do Plano",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Empresa", value: "company" },
        { text: "Tempo de Contrato", value: "contract_time" },
        { text: "Concessionária", value: "utility_company" },
        { text: "Status", value: "status" },
        { text: "Criado em", value: "created_at" },
        { text: "Desconto", value: "discount" },
        { text: "ID", value: "id", sortable: false },
        { text: "Tipo de Pessoa", value: "person_type" },
        { text: "Recomendado", value: "recommended" },
        { text: "Promocional", value: "promotional" },
        { text: "Começado em", value: "started_at" },
        { text: "Ações", sortable: false, value: "", align: "center" },
      ],
      pag: { rowsPerPage: 50 },
    };
  },

  computed: {
    ...mapState("configuration", ["loading", "plans"]),
  },

  methods: {
    ...mapMutations("configuration", ["setPlanDialog"]),
    ...mapActions("configuration", ["getPlans"]),

    startUpdate(plan, status) {
      if (status === "disabled") status = "activated";
      else status = "disabled";

      this.newPlanStatus = status;
      this.planFormData.plan = plan;
      this.dialog_modify_status_plan = true;
    },

    activateOrDesactivate() {
      if (this.newPlanStatus === "disabled") {
        this.desactivatePlan(this.plan.id);
        this.dialog_modify_status_plan = false;
      } else {
        this.activatePlan(this.plan.id);
        this.dialog_modify_status_plan = false;
      }
    },

    desactivatePlan(id) {
      let data = {
        updated_at: new Date(),
        status: "disabled",
      };
      updatePlansFb(id, data);
    },

    activatePlan(id) {
      let data = {
        updated_at: new Date(),
        status: "activated",
      };
      updatePlansFb(id, data);
    },

    openPlanForm(type, plan) {
      this.planFormData.openDialog = true;
      this.planFormData.type = type;
      this.planFormData.plan = plan;
      this.planFormData.key = this.planFormData.key + 1;
    },
  },

  mounted() {
    this.getPlans();
  },
};
</script>
